import * as React from 'react';
import {assets} from "../../helpers";
import {Link} from "react-router";
import {newsStore, News as NewsType} from "../../store";
import {DrawText} from "../../components/DrawText";

export class News extends React.Component<any, any> {
    render() {
        const news = newsStore.find();
        
        return (
            <section className="news">
                <h1>Новости выставки</h1>
                <a href="https://www.facebook.com/doctorhead.russia/?ref=ts" target="_blank"><img src={assets("sony-b2.jpg")} className="banner" /></a>
                <div className="preview">
                    {
                        news.map(item => (
                            <article key={item._id}>
                                {item.cover ?
                                    (<div className="cover">
                                        <Link to={item.link ? item.link : ("/news/" + item._id)}><img src={assets(`news/${item._id}/${item.cover}`)} className="img-responsive" /></Link>
                                        <b>{item.date}</b>
                                    </div>) : ''
                                }
                                <h2><Link to={item.link ? item.link : ("/news/" + item._id)}>{item.title}</Link></h2>
                                <div className="text">
                                    <DrawText data={item.announce || item.preview}/>
                                </div>
                                <Link to={item.link ? item.link : ("/news/" + item._id)}>Подробнее</Link>
                            </article>
                        ))
                    }
                </div>
            </section>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Main/News.tsx
 **/